<template>
  <div class="box">
    <van-nav-bar
      class="header"
      title="高校开学防疫攻略"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="menuCon">
      <div class="menuhead">
        <img src="../assets/menubanner.jpg" />
      </div>
      <div class="indexPage menuBG">
        <h1>目录</h1>
        <div class="menupage">
          <div class="menuList" v-for="(item,index) in names" :key="index">
            <router-link
              :to="item.link"
              v-track-event="{category:'link', action:'click',opt_label: item.title}"
            >
              <img :src="item.imgUrl" />
              <div class="textMenu">{{ item.title }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div>高等教育出版社 版权所有 京ICP备12020869号-1</div>
      <div>
        京ICP证150856号
        <img src="../assets/2020-gongan.png" /> 京公网安备11010202008535号
      </div>
    </div>
    <WxShare></WxShare>
  </div>
</template>

<script>
import WxShare from "../components/WxShare";
import con1 from "@/assets/menu1.png";
import con2 from "@/assets/menu2.png";
import con3 from "@/assets/menu3.png";
import con4 from "@/assets/menu4.png";
export default {
  components: {
    WxShare
  },
  data() {
    return {
      activeNames: "1",
      names: [
        {
          imgUrl: con1,
          title: "前言",
          link: "/course1"
        },
        {
          imgUrl: con2,
          title: "师生开学返校攻略",
          link: "/course2"
        },
        {
          imgUrl: con3,
          title: "在校学习生活攻略",
          link: "/course3"
        },
        {
          imgUrl: con4,
          title: "教师在校工作攻略",
          link: "/course4"
        }
      ]
    };
  },

  methods: {
    onClickLeft() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.main-content {
  padding-bottom: 7rem;
}

.menuhead {
  line-height: 0;
}

.menuhead img {
  width: 100%;
}

.menuBG {
  background: url(../assets/menubg.jpg) repeat-x center top;
  padding: 0 2rem 0 2rem;
  margin-top: -0.5rem;
}

.menuBG h1 {
  background: url(../assets/text.png) no-repeat center center;
  background-size: 50%;
  text-align: center;
  color: #097055;
  font-size: 1.8rem;
  font-weight: bold;
}

.menupage {
  overflow: hidden;
  text-align: center;
  margin-left: -2rem;
  margin-right: -2rem;
  padding-bottom: 2rem;
}

.menuList {
  background: #097055;
  width: 40%;
  display: inline-block;
  border-radius: 0.5rem;
  text-align: center;
  padding: 2rem 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  vertical-align: middle;
  margin-top: 2rem;
}

.textMenu {
  height: 6.4rem;
  color: #fff;
  vertical-align: middle;
  width: 10.8rem;
  margin: 0 auto;
}

.menuList img {
  width: 50%;
}
</style>
